/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const featureId = feature.getID();
    const DUTY = feature.getSettingValue('DUTY');
    const FREQUENCY = feature.getSettingValue('FREQUENCY');

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext("${featureId}", {
    "DUTY": ${DUTY},
    "FREQUENCY": ${FREQUENCY},
});`,
    });

    blocks.push({
        location: `var_${DUTY}_update`,
        blockType: BlockType.CODE,
        template: `var_${DUTY}_update_completed(simulator.context["${featureId}"]["DUTY"]);`,
    });

    blocks.push({
        location: `var_${FREQUENCY}_update`,
        blockType: BlockType.CODE,
        template: `var_${FREQUENCY}_update_completed(simulator.context["${featureId}"]["FREQUENCY"]);`,
    });

    blocks.push({
        location: `var_${DUTY}_set`,
        blockType: BlockType.CODE,
        template: `ioLineSet("${featureId}", "DUTY", value)`,
    });

    blocks.push({
        location: `var_${FREQUENCY}_set`,
        blockType: BlockType.CODE,
        template: `ioLineSet("${featureId}", "FREQUENCY", value)`,
    });

    return blocks;
};
